import { render, staticRenderFns } from "./BackgroundColorSelector.vue?vue&type=template&id=ac5097ec&scoped=true"
import script from "./BackgroundColorSelector.vue?vue&type=script&lang=js"
export * from "./BackgroundColorSelector.vue?vue&type=script&lang=js"
import style0 from "./BackgroundColorSelector.vue?vue&type=style&index=0&id=ac5097ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac5097ec",
  null
  
)

export default component.exports